module.exports = __webpack_public_path__ + "img/require-2.984a04ca.png";